import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapActions } from "vuex";
import { GenericModal } from "@Shared/components/modals";
import Amplitude from "@Shared/@Utils/amplitude";
import { GET_SIGNED_URL, MARK_UPLOAD_COMPLETED } from "@Broker/@Modules/clients/applications/documents/store/documents-actions";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import SimpleButton from "@Shared/components/buttons/simple-button.vue";
import { putS3Data } from "@Shared/utils/ajax";
import MaterialInput from "@Shared/components/inputs/material-input.vue";
import isPDFEncrypted from "@Shared/utils/is-pdf-encrypted";
import { showToast } from "@Shared/utils/constants";
import { defineComponent } from "@vue/composition-api";
import { isEmpty } from "lodash";
export default defineComponent({
  name: "AddDisclaimerModal",
  components: {
    GenericModal,
    SimpleButton,
    MaterialInput
  },
  mixins: [validationMixin],
  props: {
    isConsent: {
      type: Boolean,
      default: true
    },
    clientUsername: {
      type: String,
      default: ""
    },
    disclaimer: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      uploadedFile: false,
      message: null,
      file: null,
      signedFile: null,
      mandatory: false,
      loadingFile: false,
      fileStatus: false,
      loadingStatus: true,
      loading: false,
      isFileEncrypted: false,
      enabled: false,
      localDisclaimer: {}
    };
  },
  validations: {
    message: {
      required
    }
  },
  computed: {
    editing() {
      return !isEmpty(this.disclaimer);
    }
  },
  methods: _objectSpread(_objectSpread({}, mapActions("DocumentsStore", [GET_SIGNED_URL, MARK_UPLOAD_COMPLETED])), {}, {
    openFile() {
      $(this.$refs.inputFile).click();
      this.$v.$touch(); //touch the message info so it shows errors if user clicks open file button first
    },
    async onInputFile(event) {
      const files = event.target.files;
      if (!files.length) return;
      const fileToProbe = files[0];
      const extension = fileToProbe.name.split(".").pop();
      if (extension === "pdf") {
        const PDFEncrypted = await isPDFEncrypted(fileToProbe);
        if (PDFEncrypted) {
          showToast("info", `fileIsProtected|{fileName:${fileToProbe.name}}`);
          this.isFileEncrypted = true;
        }
      }
      this.file = fileToProbe;
      this.uploadedFile = true;
    },
    async createDisclaimer() {
      if (this.$v.$invalid) return;
      this.loading = true;
      if (this.uploadedFile && this.file) await this.uploadDocument();
      const mandatory = this.isConsent || this.mandatory;
      const file = this.uploadedFile ? {
        fileName: this.file.name,
        documentId: this.signedFile.documentId
      } : {};
      this.$emit("create-disclaimer", _objectSpread({
        consent: this.isConsent,
        description: this.message,
        mandatory,
        enabled: this.enabled
      }, file));
    },
    async uploadDocument() {
      this.signedFile = await this.GET_SIGNED_URL({
        fileName: this.file.name,
        documentRequestId: null
      });
      if (!this.signedFile) {
        this.loadingFile = false;
        this.fileStatus = false;
        this.removeFile();
        return;
      }
      await putS3Data(this.file, this.signedFile.url, this.signedFile.contentType);
      await this.MARK_UPLOAD_COMPLETED({
        clientUsername: this.clientUsername,
        classificationType: "disclaimer",
        documentS3Key: this.signedFile.documentId,
        documentRequestId: null,
        encrypted: this.isFileEncrypted
      });
      if (this.editing) {
        const file = this.uploadedFile ? {
          fileName: this.file.name,
          documentId: this.signedFile.documentId
        } : {};
        this.localDisclaimer = _objectSpread(_objectSpread({}, this.localDisclaimer), file);
      }
      Amplitude.logEvent("Disclaimers - file added");
    },
    removeFile() {
      $(this.$refs.inputFile).val("");
      this.file = null;
      this.uploadedFile = false;
      if (this.editing) {
        delete this.localDisclaimer.fileName;
        delete this.localDisclaimer.documentId;
      }
    },
    async saveCurrentDisclaimer() {
      this.loading = true;
      this.localDisclaimer.description = this.message;
      if (this.uploadedFile && this.file) await this.uploadDocument();
      this.$emit("edit-disclaimer", this.localDisclaimer);
    },
    async handleShow() {
      await this.$nextTick();
      if (this.editing) {
        var _this$disclaimer$desc, _this$disclaimer;
        this.localDisclaimer = this.disclaimer;
        this.message = (_this$disclaimer$desc = (_this$disclaimer = this.disclaimer) == null ? void 0 : _this$disclaimer.description) != null ? _this$disclaimer$desc : "";
        const {
          fileName = ""
        } = this.disclaimer;
        this.uploadedFile = !!fileName;
      }
      await this.$nextTick();
      Amplitude.logEvent("Add disclaimer modal - shown", {
        source: "modal"
      });
    },
    async handleHidden() {
      this.message = null;
      this.mandatory = false;
      this.enabled = false;
      this.localDisclaimer = {};
      this.loading = false;
      this.loadingStatus = true;
      this.removeFile();
      this.$v.$reset();
      Amplitude.logEvent("Add disclaimer modal - hidden", {
        source: "modal"
      });
      this.$emit("hidden");
    },
    show() {
      this.$refs.addDisclaimer.show();
    },
    hide() {
      this.$refs.addDisclaimer.hide();
    }
  })
});